import { Heading } from "@/components/ui/heading";
import { RegularPageLayout } from "@/components/layout/PageLayouts";
export default function FaqPage() {
	return (
		<RegularPageLayout width="6xl" paddingY="8">
			<section className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
				<Heading>FAQ</Heading>
				<div className="mt-6 space-y-5 text-sm leading-7 text-slate-700 sm:text-base">
					<div>
						<p className="font-semibold text-slate-900">What does Text Formatter do?</p>
						<p>
							It cleans messy text, improves spacing, detects structure, and outputs either plain
							text or HTML.
						</p>
					</div>
					<div>
						<p className="font-semibold text-slate-900">Can I use it for free?</p>
						<p>
							Yes. The web app is free. If you need API access, you get a free API key with a
							generous word limit.
						</p>
					</div>
					<div>
						<p className="font-semibold text-slate-900">Which content types are supported?</p>
						<p>
							Text Formatter supports plain text, web content, and ecommerce product content with
							mode-specific formatting options.
						</p>
					</div>
					<div>
						<p className="font-semibold text-slate-900">Can I integrate it into my app?</p>
						<p>
							Yes. Use the `/v1/format` API endpoint with your API key to automate formatting in
							your own workflows. You will find examples of API usage if you log-in.
						</p>
					</div>
					<div>
						<p className="font-semibold text-slate-900">Where can I find TextFormatter API?</p>
						<p>
							The API is available at:{" "}
							<a
								href="https://api.textformatter.pro"
								target="_blank"
								rel="noreferrer"
								className="font-medium text-slate-900 underline underline-offset-2 hover:text-slate-700"
							>
								https://www.api.textformatter.pro
							</a>
						</p>
					</div>
				</div>
			</section>
		</RegularPageLayout>
	);
}
